import React from 'react';

/**
 * Motifs repris de la géométrie du CV : la forme « stade » du cadre photo,
 * le point relié par un filet, et la puce des frises. Rien de décoratif qui
 * ne vienne du document imprimé.
 */

/** Grande forme « stade » en filet, en filigrane derrière le hero. */
export function StadiumMark({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 200 280"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="1"
        y="1"
        width="198"
        height="278"
        rx="99"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="26"
        y="26"
        width="148"
        height="228"
        rx="74"
        stroke="currentColor"
        strokeWidth="1"
        opacity="0.6"
      />
    </svg>
  );
}

/** Point relié par un filet, comme entre le nom et le portrait sur le CV. */
export function DotLeader({ className }) {
  return (
    <span className={`cv-dotleader ${className || ''}`} aria-hidden="true">
      <span className="cv-dotleader-dot" />
      <span className="cv-dotleader-line" />
    </span>
  );
}

/** Filet fin avec un point centré, séparateur entre deux sections. */
export function Divider({ className }) {
  return (
    <div className={`cv-divider ${className || ''}`} aria-hidden="true">
      <span className="cv-divider-line" />
      <span className="cv-divider-mark" />
      <span className="cv-divider-line" />
    </div>
  );
}
